import React from "react";
import { useTranslation } from "react-i18next";
import { SubprocessItemRow } from "./OSSubprocessItemsTable";
import RNMaterialPriemRow from "./RNMaterialPriemRow";
import { OS_TH_CLS } from "./OSCard";

export interface RNMaterialPriemRowData extends SubprocessItemRow {
  subprocessName?: string;
  issuedQty?: string;
  documentTypeCode?: string;
  documentNumber?: string;
}

interface Props {
  rows: RNMaterialPriemRowData[];
  isSaving?: boolean;
  currentUserId?: string;
  onPatchActual: (index: number, patch: Partial<SubprocessItemRow>) => void;
  onPatchActualAndSave: (index: number, patch: Partial<SubprocessItemRow>) => void;
  isSaveQueued: (rowKey: string) => boolean;
}

const TH: React.FC<{ w: number; title?: string; children: React.ReactNode }> = ({ w, title, children }) => (
  <th
    className={`${OS_TH_CLS} whitespace-nowrap`}
    style={{ width: w }}
    title={title}
  >
    {children}
  </th>
);

const RNMaterialPriemRows: React.FC<Props> = ({ rows, isSaving, currentUserId, onPatchActual, onPatchActualAndSave, isSaveQueued }) => {
  const { t } = useTranslation();

  return (
    <div className="overflow-x-auto">
      <table className="border-collapse w-full table-fixed min-w-[1855px]">
        <thead>
          <tr>
            <TH w={34} title={t('os.materialno.priemColPriority')}>РБ</TH>
            <TH w={80}>{t('os.materialno.priemColSubprocess')}</TH>
            <TH w={86}>{t('os.materialno.priemColIdent')}</TH>
            <TH w={170}>{t('os.materialno.priemColName')}</TH>
            <TH w={40}>{t('os.materialno.priemColUnit')}</TH>
            <TH w={65} title={t('os.materialno.priemColPlannedQty')}>План. к.</TH>
            <TH w={65} title={t('os.materialno.priemColIssuedQty')}>Издадено</TH>
            <TH w={60} title={t('os.materialno.priemColSecondaryQty')}>Спор. к.</TH>
            <TH w={60} title={t('os.materialno.priemColAllowedWaste')}>Дозв. о.</TH>
            <TH w={60} title={t('os.materialno.priemColAllowedYield')}>Дозв. п.</TH>
            <TH w={70} title={t('os.materialno.priemColFromToPct')}>Од/До %</TH>
            <TH w={70} title={t('os.materialno.priemColReceivedQty')}>Прим. кол.</TH>
            <TH w={60} title={t('os.materialno.priemColUzurkuvanje')}>Узорк.</TH>
            <TH w={90}>{t('os.materialno.priemColLot')}</TH>
            <TH w={80} title={t('os.materialno.priemColExpiry')}>Рок</TH>
            <TH w={55}>{t('os.materialno.priemColSpillage')}</TH>
            <TH w={55}>{t('os.materialno.priemColWaste')}</TH>
            <TH w={55} title={t('os.materialno.priemColYieldPct')}>Прин. %</TH>
            <TH w={70} title={t('os.materialno.priemColDeviation')}>Отстап.</TH>
            <TH w={115}>{t('os.materialno.priemColJustification')}</TH>
            <TH w={50} title={t('os.materialno.priemColDocType')}>Вид</TH>
            <TH w={85}>{t('os.materialno.priemColDocument')}</TH>
            <TH w={40} title={t('os.materialno.priemColConfirmed')}>✓</TH>
            <TH w={120} title={t('os.materialno.priemColWorkedBy')}>Работел</TH>
            <TH w={120} title={t('os.materialno.priemColVerifiedBy')}>Проверил</TH>
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 ? (
            <tr>
              <td className="border border-gray-300 h-[26px] px-2 py-0.5 text-[11px] text-gray-400 italic" colSpan={25}>
                {t('os.materialno.priemNoRows')}
              </td>
            </tr>
          ) : rows.map((row, index) => (
            <RNMaterialPriemRow
              key={row.rowId || index}
              row={row}
              isSaving={isSaving}
              currentUserId={currentUserId}
              onPatchActual={(patch) => onPatchActual(index, patch)}
              onPatchActualAndSave={(patch) => onPatchActualAndSave(index, patch)}
              isSaveQueued={isSaveQueued(row.rowId || '')}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default RNMaterialPriemRows;
